module.exports = __webpack_public_path__ + "static/img/code.3fc0353.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme1/code.png
// module id = 1Wsz
// module chunks = 73